import React, { useEffect, useState } from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from '@mui/material';
import { buildingCorpsApi } from '../../api/buildingCorps';

const EditCorpsDialog = ({ open, onClose, corps, onSaved }) => {
  const [form, setForm] = useState({ name: '' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (open && corps) {
      setForm({ name: corps?.name || '' });
      setError('');
    }
  }, [open, corps]);

  const handleChange = (e) => {
    setForm({ name: e.target.value });
  };

  const handleSubmit = async () => {
    const name = (form.name || '').trim();
    if (!name) {
      setError('Укажите название корпуса.');
      return;
    }
    if (!corps?.id || !corps?.buildingId) return;
    setSaving(true);
    setError('');
    try {
      await buildingCorpsApi.update(String(corps.id), {
        name,
        building_id: String(corps.buildingId),
      });
      onSaved?.();
    } catch (err) {
      setError(err?.response?.data?.detail || err?.message || 'Не удалось сохранить изменения');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={saving ? undefined : onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Редактирование корпуса</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          {error && <Alert severity="error">{error}</Alert>}
          <TextField
            label="Название"
            value={form.name}
            onChange={handleChange}
            autoFocus
            fullWidth
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          Отмена
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={saving || !corps?.id || !corps?.buildingId}
        >
          {saving ? 'Сохранение...' : 'Сохранить'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditCorpsDialog;
